import { render, staticRenderFns } from "./CustomerReceita.vue?vue&type=template&id=e1cf6f38"
import script from "./CustomerReceita.vue?vue&type=script&lang=js"
export * from "./CustomerReceita.vue?vue&type=script&lang=js"
import style0 from "./CustomerReceita.vue?vue&type=style&index=0&id=e1cf6f38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports